import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

const mixinAlert = {
  methods: {
    showMessageErrors(error) {
      console.log(error);
      this.showHideLoading();

      let msg = `${i18n.t('common_words.ups')}<br/><br/>`;
      if (error.response && error.response.data && error.response.data.errors) {
        let i = 1;
        for (var key in error.response.data.errors) {
          msg += `${i++}. ${error.response.data.errors[key]} <br/>`;
        }
      } else {
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            msg = error.response.data.message;
          } else {
            if (error.response.data.errorcode) {
              msg = error.response.data.error;
            } else {
              msg = i18n.t('common_words.error_sending_info');
            }
          }
        } else {
          msg =
            i18n.t('common_words.error_sending_info') +
            (error ? '"' + error + '"' : '');
        }
      }

      if (
        error.response &&
        ((error.response.data.code && error.response.data.code === 474, 422) ||
          (error.response.status && error.response.status === 422))
      )
        SweetAlert.warning(msg);
      else SweetAlert.danger(msg);
    },
  },
};

export default mixinAlert;
